import Shape from './Shape.js';

export default class Property extends Shape {
  #isOptional;
  #isPrimary;
  #connector;
  #connectedTo;
  #lsAnnotatedName;
  #lpAnnotatedName;

  constructor(
    id,
    name,
    type,
    position,
    isPrimary,
    connectedEntity,
    isOptional = false
  ) {
    super(id, name, type, position);
    this.#isOptional = isOptional;
    this.#isPrimary = isPrimary;
    this.#connectedTo = connectedEntity;
    this.#lsAnnotatedName = [];
    this.#lpAnnotatedName = [];
  }

  setOptional() {
    this.#isOptional = true;
  }

  setNotOptional() {
    this.#isOptional = false;
  }

  getIsOptional() {
    return this.#isOptional;
  }

  setAsPrimaryKey() {
    this.#isPrimary = true;
    this.#isOptional = false;
  }

  setAsNotPrimary() {
    this.#isPrimary = false;
    this.#connector = undefined;
  }

  getIsPrimary() {
    return this.#isPrimary;
  }

  setConnectedEntity(entity) {
    this.#connectedTo = entity;
  }

  getConnectedEntity() {
    return this.#connectedTo;
  }

  addLSAnnotationName(name) {
    this.#lsAnnotatedName.push(name);
  }

  getLSAnnotationNameAt(index) {
    return this.#lsAnnotatedName[index];
  }

  getLSAnnotationNames() {
    return this.#lsAnnotatedName;
  }

  addLPAnnotationName(name) {
    this.#lpAnnotatedName.push(name);
  }

  getLPAnnotationNameAt(index) {
    return this.#lpAnnotatedName[index];
  }

  getLPAnnotationNames() {
    return this.#lpAnnotatedName;
  }

  getAnnotatedName() {
    if (this.#lsAnnotatedName.length === 0) {
      return `${this.#lpAnnotatedName.join(',')}\n${this.getName()}`;
    } else if (this.#lpAnnotatedName.length === 0) {
      return `${this.#lsAnnotatedName.join(',')}\n${this.getName()}`;
    } else {
      return `${this.#lsAnnotatedName.join(',')}\n${this.#lpAnnotatedName.join(
        ','
      )}\n${this.getName()}`;
    }
  }

  getSavedObject() {
    return {
      name: this.getName(),
      type: this.getType(),
      isOptional: this.#isOptional,
      isPrimary: this.#isPrimary,
      position: this.getPosition(),
    };
  }

  deleteConnector() {
    this.#connector = undefined;
  }

  setConnector(connector) {
    this.#connector = connector;
  }

  getConnector() {
    return this.#connector;
  }
}
